import FeatureService from '../../../../services/feature-service/feature.service';
import { FeatureTypes } from '../../../../services/feature-service/features.enum';

export default class CustomBlocksFeatureValidation {
	public isFeatureEnabled = (featureService: FeatureService) => {
		const isCustomBlocksEnabled = featureService.checkFeatureIsSetAndEnabled(FeatureTypes.CUSTOM_BLOCKS);
		return isCustomBlocksEnabled;
	};
}
